import { Reducer } from 'redux'
import * as types from '../constantes/user'

export const CreateUserReducer: Reducer = (state = {}, action) => {
  switch (action.type) {
    case types.CREATE_REGISTER_REQUEST:
      return {
        loading: true
      }

    case types.CREATE_REGISTER_SUCCESS:
      return {
        loading: false,
        success: action.payload
      }

    case types.CREATE_REGISTER_ERROR:
      return {
        loading: false,
        error: action.payload
      }

    case types.CREATE_REGISTER_RESET:
      return {}

    default:
      return state
  }
}

export const ListRegisterReducer: Reducer = (state = {}, action) => {
  switch (action.type) {
    case types.LIST_REGISTER_REQUEST:
      return {
        loading: true
      }

    case types.LIST_REGISTER_SUCCESS:
      return {
        loading: false,
        listRegisters: action.payload
      }

    case types.LIST_REGISTER_ERROR:
      return {
        loading: false,
        error: action.payload
      }

    case types.LIST_REGISTER_RESET:
      return {}

    default:
      return state
  }
}
